/**
 * 첫번째 문자를 대문자로 나머진 소문자로 변환
 * @param str
 * @returns
 */
const toFirstUpperCaseOtherLowerCase = (str?: string) => {
  if (!str) {
    return "";
  }

  if (str.length === 1) {
    return str.charAt(0).toUpperCase();
  }

  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export { toFirstUpperCaseOtherLowerCase };
